<template>
    <div>
        <div id="page">
            <Header></Header>
        <div class="swipe01">
            <div class="swipe01-head swipe01-tr">
                <div class="swipe01-td">序号</div>
                <div class="swipe01-td">委托人</div>
                <div class="swipe01-td">委托目标</div>
                <div class="swipe01-td">委托面积</div>
                <div class="swipe01-td">投标结果</div>
                <div class="swipe01-td">成交状态</div>
            </div>
            <div class="swipe01-body">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad">
                    <van-swipe-cell class="wrap" :right-width="rightWidth" v-for="(item, index) in list">
                        <div class="swipe01-tr">
                            <div class="swipe01-td">{{ index+1 }}</div>
                            <div class="swipe01-td">{{ item.bider_name }}</div>
                            <div class="swipe01-td">{{ item.target }}</div>
                            <div class="swipe01-td">{{ item.area }}</div>
                            <div class="swipe01-td">{{ item.bided_status }}</div>
                        </div>
                        <div class="swipe01-tool" slot="right">
                            <div class="btn s1" @click='viewUserBided(item.bided_id)'>查看</div>
                        </div>
                    </van-swipe-cell>
                </van-list>
            </div>
        </div>
        </div>

        <Footer></Footer>


        <van-popup v-model="showPop" :overlay="true">
            <div class="pop-consign">
                <div class="close" @click="showPop = false"></div>
                <div class="consign-info">
                    <div class="consign-item bdb">
                        <div class="lab">招标结果</div>
                        <div class="val">{{ bided_info.bided_status }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">投标信息</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">投标房源</div>
                        <div class="val">{{ house_info.house_name }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">详细地址</div>
                        <div class="val">{{ house_info.address }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">面积</div>
                        <div class="val">{{ house_info.area }}</div>
                    </div>
                    <div class="consign-item bdb">
                        <div class="lab">价格</div>
                        <div class="val">{{ house_info.rent_sale_price }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">招标信息</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">委托人</div>
                        <div class="val">{{ entrust_info.bider_name }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">发布人类型</div>
                        <div class="val">{{ entrust_info.faburen_type }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">委托目标</div>
                        <div class="val">{{ entrust_info.target }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">委托面积</div>
                        <div class="val">{{ entrust_info.area }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">委托类型</div>
                        <div class="val">{{ entrust_info.re_type }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">预算金额</div>
                        <div class="val">{{ entrust_info.budget }}</div>
                    </div>
                    <div class="consign-item">
                        <div class="lab">其他要求</div>
                        <div class="val">{{ entrust_info.detail }}</div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script scoped>

    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import { SwipeCell, Popup, Dialog, Toast, List } from 'vant'

    export default {
        name: "UserBidedList",
        data: function () {
            return {
                rightWidth: document.body.clientWidth/750*100,
                showPop: false,
                loading: false,
                finished: false,
                list: [],
                page: 1,
                bided_info: {},
                entrust_info: {},
                house_info: {}
            }
        },
        components: {
            Header, Footer,
            [SwipeCell.name]: SwipeCell,
            [Dialog.name]: Dialog,
            [Popup.name]: Popup,
            [Toast.name]: Toast,
            [List.name]: List
        },
        mounted(){
            this.getList();
        },
        methods: {
            getList () {
                const _this = this;
                _this.api.getUserBidedList({
                    page: _this.page,
                    pageSize: 20
                }).then(function(response){
                    _this.loading = false;
                    _this.page++;
                    if (response.bided_list.length < 20) {
                        _this.finished = true;
                    }
                    _this.list = _this.list.concat(response.bided_list);
                })
            },
            viewUserBided (id) {
                const _this = this;
                let params = new FormData();
                params.append('Bided_id', id);
                _this.api.viewUserBided(params).then(function(response){
                    _this.showPop = true;
                    _this.bided_info = response.bided_info;
                    _this.entrust_info = response.entrust_info;
                    _this.house_info = response.house_info;
                })
            },
            onLoad(){
                setTimeout(()=>{
                    this.getList();
                }, 500)
            }
        }
    }
</script>

<style scoped>
    /deep/ .swipe01-tool {width: 1rem;}
</style>
